import { render } from "./legoRadioWrapper.vue?vue&type=template&id=60a314d6"
import script from "./legoRadioWrapper.vue?vue&type=script&lang=js"
export * from "./legoRadioWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoRadio/legoRadioWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60a314d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60a314d6', __exports__)) {
    api.reload('60a314d6', __exports__)
  }
  
  module.hot.accept("./legoRadioWrapper.vue?vue&type=template&id=60a314d6", () => {
    api.rerender('60a314d6', render)
  })

}


export default __exports__